import { createSelector, createSlice } from '@reduxjs/toolkit';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { clearResetPasswordInput, refreshResetPasswordState, } from '../../forms/ResetPassword/resetPasswordSlice.js';
import { clearRegistrationInputs } from '../../forms/Registration/registrationSlice.js';
import { clearLoginInputs } from '../../forms/Login/loginSlice.js';
export const initialModalState = {
    activeModalType: null,
    isGDPRModalActive: false,
};
export const modalSlice = createSlice({
    name: 'modal',
    initialState: initialModalState,
    reducers: {
        showModal: (state, actions) => {
            state.activeModalType = actions.payload;
        },
        hideModal: (state) => {
            state.activeModalType = null;
        },
        setGDPRModalActive: (state, actions) => {
            state.isGDPRModalActive = actions.payload;
        },
    },
});
export const closeModalThunk = () => async (dispatch) => {
    dispatch(clearLoginInputs());
    dispatch(clearRegistrationInputs());
    dispatch(clearResetPasswordInput());
    dispatch(refreshResetPasswordState());
    dispatch(modalActions.hideModal());
};
export const modalActions = modalSlice.actions;
const loginRegistrationModalState = (state) => state.wrappers.modal;
export const activeModalTypeSelector = createSelector(loginRegistrationModalState, (state) => state?.activeModalType);
export const isModalVisible = (modalType) => createSelector(loginRegistrationModalState, ({ activeModalType }) => {
    return activeModalType === modalType;
});
export const isExternalModalVisibleSelector = createSelector(loginRegistrationModalState, (state) => state.forms.registration, ({ activeModalType }, registrationState) => {
    return (activeModalType === FORM_TYPES.REGISTRATION &&
        registrationState.showRegistrationSuccessfulModal === true);
});
export const isGDPRModalActiveSelector = createSelector(loginRegistrationModalState, (state) => state?.isGDPRModalActive);
export default modalSlice.reducer;
//# sourceMappingURL=modalSlice.js.map